/**
 * Paginação agrupada da impressão do lote — lógica pura, sem React.
 *
 * Vive fora do modal de propósito: assim dá para testar sem arrastar jsPDF /
 * html2canvas, e a regra de negócio ("a foto sai na mesma folha do
 * comprovante dela") fica num lugar só.
 */

/**
 * Distribui as peças nas folhas MANTENDO cada solicitação junto das imagens
 * dela sempre que couber.
 *
 * A regra é uma só: um grupo que caberia inteiro numa folha, mas não no
 * espaço que sobrou da folha atual, começa na próxima. Grupo maior que a
 * folha não tem jeito — enche em sequência (mas o grupo seguinte volta a ser
 * protegido pela regra).
 *
 * Sem isso, o comprovante da ASM-2 cairia na folha 1 e a foto dela na folha
 * 2, que é exatamente o que o chão de fábrica não pode receber.
 *
 * @param {Array<{solicitacaoId: string}>} pecas na ordem desejada
 * @param {number} porPagina células por folha (1, 2 ou 4)
 * @returns {Array<Array<object>>} uma lista de peças por folha
 */
export function montarPaginasAgrupadas(pecas, porPagina) {
  const grupos = [];
  const porSolicitacao = new Map();
  (pecas || []).forEach((peca) => {
    let grupo = porSolicitacao.get(peca.solicitacaoId);
    if (!grupo) {
      grupo = [];
      porSolicitacao.set(peca.solicitacaoId, grupo);
      grupos.push(grupo);
    }
    grupo.push(peca);
  });

  const paginas = [];
  let atual = [];
  const fecharPagina = () => {
    if (atual.length) {
      paginas.push(atual);
      atual = [];
    }
  };

  grupos.forEach((grupo) => {
    const livre = porPagina - atual.length;
    if (grupo.length <= porPagina && grupo.length > livre) fecharPagina();
    grupo.forEach((peca) => {
      if (atual.length === porPagina) fecharPagina();
      atual.push(peca);
    });
  });
  fecharPagina();
  return paginas;
}
